import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';

import { Assignment } from '../types';

import { getAssignmentsQuery, GetAssignmentsQueryResult, GetAssignmentsQueryVariables } from '../graphql/queries/getAssignmentsQuery';

export interface AssignmentsHookPayload {
  loading: boolean;
  error?: string;
  assignments?: Assignment[];
}

interface AssignmentsHookInput {
  courseId: string;
}

export default function useAssignments(input: AssignmentsHookInput): AssignmentsHookPayload {
  const { courseId } = input;

  const { data, loading, error } = useQuery<GetAssignmentsQueryResult, GetAssignmentsQueryVariables>(getAssignmentsQuery, {
    variables: { courseId },
    fetchPolicy: 'cache-and-network',
  });

  return { loading, error: getErrorMessage({ error }), assignments: data?.assignments };
}
